
import React from 'react';
import PropTypes from 'prop-types';

import './StatusBadge.css';
const getCloudCertificationTemplate = (type) => {
  const statusUIDetails = {
    materialicon: '',
    wrapperClassName: '',
    textClassName: '',
    iconClassName: '',
    text: ''
  };

  switch (type) {
    case 'needs info':
      statusUIDetails.materialicon = 'warning';
      statusUIDetails.wrapperClassName = 'NeedsInfo';
      statusUIDetails.textClassName = '';
      statusUIDetails.iconClassName = 'NeedsInfoIcon';
      statusUIDetails.text = 'Certificate Needs Info';
      break;
    case 'verified':
      statusUIDetails.materialicon = 'check_circle';
      statusUIDetails.wrapperClassName = 'verified';
      statusUIDetails.textClassName = '';
      statusUIDetails.iconClassName = 'verifiedIcon';
      statusUIDetails.text = 'Verified';
      break;
    case 'verification pending':
      statusUIDetails.materialicon = 'visibility';
      statusUIDetails.wrapperClassName = 'underreview';
      statusUIDetails.textClassName = '';
      statusUIDetails.iconClassName = 'underreviewIcon';
      statusUIDetails.text = 'Under Review';
      break;
    case 'rejected':
      statusUIDetails.materialicon = 'cancel';
      statusUIDetails.wrapperClassName = 'cancel';
      statusUIDetails.iconClassName = 'cancelIcon';
      statusUIDetails.textClassName = '';
      statusUIDetails.text = 'Rejected';
      break;
    case 'expired':
      statusUIDetails.materialicon = 'timelapse';
      statusUIDetails.wrapperClassName = 'expired';
      statusUIDetails.iconClassName = 'expiredIcon';
      statusUIDetails.textClassName = '';
      statusUIDetails.text = 'Expired';
      break;
  }

  return <div>
    <div className={`CertificateStatusUi-common ${statusUIDetails.wrapperClassName}`}>
      <span className={`material-icons  CertificateStatusIcon-common ${statusUIDetails.iconClassName}`} >{statusUIDetails.materialicon}</span>
      <span>{statusUIDetails.text}</span>
    </div>
  </div>;
};

const StatusBadge = ({ type }) => {
  return getCloudCertificationTemplate(type);
};

StatusBadge.propTypes = {
  type: PropTypes.string
};

export default StatusBadge;
